import * as TYPES from './signup-actiontypes';

export const initialState = {
  isShowCancelModal: false,
  verificationFields: [],
  authorizedRepData: { encryptedInvitationId: null, pin: null, email: null },
  password: {},
};

export const signupReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TYPES.SHOW_CANCEL_MODAL:
      newState = { ...state, isShowCancelModal: action.isShowCancelModal };
      break;
    case TYPES.LOAD_VERIFICATION_FIELDS_SUCCESS:
      newState = { ...state, verificationFields: action.verificationFields };
      break;
    case TYPES.LOAD_PASSWORD_RULES:
      newState = { ...state,
        password: {
          minLength: action.password.minLength,
          capitalLetters: action.password.capitalLetters,
          numbers: action.password.numbers,
          specialCharacters: action.password.specialCharacters,
        } };
      break;
    case TYPES.SET_SIGN_UP_VERIFIED_IDENTITY_DATA:
      newState = { ...state, verifiedIdentityData: action.verifiedIdentityData };
      break;
    case TYPES.SET_AUTHORIZED_REP_DATA:
      newState = { ...state,
        authorizedRepData: action.authorizedRepData };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default signupReducer;
